import GroupIcon from '@material-ui/icons/Group';

export const UserIcon = GroupIcon;
